
import { defineComponent } from 'vue';
import HeadBar from '@/components/Common/HeadBar.vue';
import TopBar from '@/components/Common/TopBar.vue';
import BulletinBar from '@/components/Common/BulletinBar.vue';
import Online from '@/components/OnlineService/Online.vue';

export default defineComponent({
  name: 'Home',
  components: { HeadBar, TopBar, BulletinBar, Online },
});
